import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import CartaoItem from "./CartaoItem";
import styles from "../styles/ModalAlterarPagamento.module.scss";

/**
 * Modal para alterar a forma de pagamento com animacao de abertura/fechamento.
 *
 * @param {boolean} aberto - Controla a visibilidade do modal
 * @param {Function} onFechar - Callback para fechar o modal
 * @param {Array} cartoes - Lista de cartoes cadastrados
 * @param {Object} cartao_selecionado - Cartao atualmente selecionado
 * @param {Function} onSelecionarCartao - Callback ao selecionar um cartao
 * @param {Function} onAdicionarCartao - Callback ao clicar em adicionar cartao
 */
export default function ModalAlterarPagamento({
  aberto,
  onFechar,
  cartoes,
  cartao_selecionado,
  onSelecionarCartao,
  onAdicionarCartao,
}) {
  const [visivel, setVisivel] = useState(aberto);
  const [saindo, setSaindo] = useState(false);

  useEffect(() => {
    if (aberto) {
      setVisivel(true);
      setSaindo(false);
    } else if (visivel) {
      setSaindo(true);

      const timer = setTimeout(() => {
        setVisivel(false);
        setSaindo(false);
      }, 220);

      return () => clearTimeout(timer);
    }
  }, [aberto]);

  if (!visivel) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={`${styles.overlay} ${saindo ? styles.saindo : ""}`} onClick={onFechar}>
      <div className={`${styles.modal} ${saindo ? styles.modalSaindo : ""}`} onClick={(evento) => evento.stopPropagation()}>
        <div className={styles.modalHeader}>
          <p className={styles.modalTitulo}>Alterar forma de pagamento</p>
          <button className={styles.modalFechar} onClick={onFechar}>×</button>
        </div>

        <div className={styles.modalBody}>
          {cartoes.map((cartao) => (
            <CartaoItem
              key={cartao.id}
              cartao={cartao}
              selecionado={cartao_selecionado?.id === cartao.id}
              onClick={() => onSelecionarCartao(cartao)}
              modo="selecionar"
            />
          ))}

          <button className={styles.botaoAdicionarCartao} onClick={onAdicionarCartao}>
            Adicionar cartão +
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
